import axios from 'axios'

var axiosFile = axios.create({
    baseURL: "https://www.districloud.net/app/documents/upload/index.php"
})

export default axiosFile
